import { memo } from "react";


export const FailedLogin = memo(() => {
  return <p>ログイン失敗です。</p>;
});